import {Component, OnInit, Inject, Input, HostListener} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {DocumentMetadataService} from "../../../api/service/documentMetadata.service";
import {MetadataDefinitionService} from "../../../api/service/metadataDefinition.service";

import {FilterDocumentMetadata} from "../../../api/model/filterDocumentMetadata";
import {FilterDocumentMetadataFilterMetadata} from "../../../api/model/filterDocumentMetadataFilterMetadata";

import {FilterDocumentMetadataNumberOperationEnum} from "../../../api/model/filterDocumentMetadataNumberOperationEnum";
import {FilterDocumentMetadataTextOperationEnum} from "../../../api/model/filterDocumentMetadataTextOperationEnum";
import {FilterDocumentMetadataDateTimeOperationEnum} from "../../../api/model/filterDocumentMetadataDateTimeOperationEnum";
import {MetadataDefinition} from "../../../api/model/metadataDefinition";
import {MetadataDefinitionEnum} from "../../../api/model/metadataDefinitionEnum";

import { SharedService } from '../../service/shared.service';
import { NxMessageToastService } from '@aposin/ng-aquila/message';

interface OperationCode {
  key: string;
  value: string;
}

@Component({
	selector: 'app-search',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit  {
  WRONG_NUMERIC_MSG: string = "Es wurde ein falscher Wert (nur Zahlen/Ziffern sind erlaubt) eingegeben. Bitte die Eingabe korrigieren.";
	loader = true;
	showError = true;
	isFocus = false;
	selected = "EQUAL";

	filter: FilterDocumentMetadata = {};
	operationCodesText: OperationCode[] = [];
	operationCodesDateTime: OperationCode[] = [];
	operationCodesNumeric: OperationCode[]  = [];

	documentCategoryData: MetadataDefinition[] = [];
	documentTypeData: MetadataDefinition[] = [];
	documentStatusData: MetadataDefinition[] = [];
	confidentialityLevelData: MetadataDefinition[] = [];
	documentProcessedData: MetadataDefinition[] = [];
	dataProtectionData: MetadataDefinition[] = [];
	countriesData: MetadataDefinition[] = [];
	inOutFlagData: MetadataDefinition[] = [];
	documentChannelData: MetadataDefinition[] = [];
	deliverySystemData: MetadataDefinition[] = [];

	myMap: Map<string, string> = new Map();
  isInteger: { [key: string]: boolean } = {
    coverProcessId: true,
    policyHolderId: true,
    foreignCustomerId: true,
    contractNumber: true
  };

	constructor(
    private readonly documentMetadataService: DocumentMetadataService,
    private readonly oauthService: OAuthService,
    private readonly sharedService: SharedService,
    private readonly metadataDefinitionService: MetadataDefinitionService
	) {
		this.filter.filterMetadata = {};
	}

	ngOnInit(): void {
	  for (let [key, value] of this.myMap.entries()) {
	    if (this.filter && this.filter.filterMetadata) {
				this.filter.filterMetadata[key] = value;
			}
		}

		this.documentMetadataService.configuration.apiKeys = {Authorization: `Bearer ${this.oauthService.getAccessToken()}` };
		this.metadataDefinitionService.configuration.apiKeys = {Authorization: `Bearer ${this.oauthService.getAccessToken()}` };

		this.loadDropdownData(MetadataDefinitionEnum.COUNTRY, this.countriesData);
		this.loadDropdownData(MetadataDefinitionEnum.DOCUMENTCATEGORY, this.documentCategoryData);
		this.loadDropdownData(MetadataDefinitionEnum.DOCUMENTTYPE, this.documentTypeData);
		this.loadDropdownData(MetadataDefinitionEnum.DOCUMENTSTATUS, this.documentStatusData);
		this.loadDropdownData(MetadataDefinitionEnum.DOCUMENTPROCESSED, this.documentProcessedData);
		this.loadDropdownData(MetadataDefinitionEnum.CONFIDENTIALITYLEVEL, this.confidentialityLevelData);
		this.loadDropdownData(MetadataDefinitionEnum.DATAPROTECTION, this.dataProtectionData);
		this.loadDropdownData(MetadataDefinitionEnum.INOUTFLAG, this.inOutFlagData);
		this.loadDropdownData(MetadataDefinitionEnum.DOCUMENTCHANNEL, this.documentChannelData);
		this.loadDropdownData(MetadataDefinitionEnum.DELIVERYSYSTEM, this.deliverySystemData);

		Object.entries(FilterDocumentMetadataNumberOperationEnum).forEach(([key, value]) => {
			let operationCode: OperationCode = {key: key, value: value};
			this.operationCodesNumeric.push(operationCode);
		});
		Object.entries(FilterDocumentMetadataDateTimeOperationEnum).forEach(([key, value]) => {
			let operationCode: OperationCode = {key: key, value: value};
			this.operationCodesDateTime.push(operationCode);
		});
		Object.entries(FilterDocumentMetadataTextOperationEnum).forEach(([key, value]) => {
			let operationCode: OperationCode = {key: key, value: value};
			this.operationCodesText.push(operationCode);
		});

		this.loader = false;
	}

	loadDropdownData(metadataDefinitionEnum: MetadataDefinitionEnum, metadataDefinitiondData: MetadataDefinition[]) {
	  metadataDefinitiondData.push({key: '', value: ''});
		this.metadataDefinitionService.metadatadefinitionGet(metadataDefinitionEnum).subscribe((data: MetadataDefinition[]) => {
			data.forEach((item: MetadataDefinition) => {
   	    for (const [key, value] of Object.entries(item)) {
					metadataDefinitiondData.push({key: key, value: value});
				}
			});
  	});
	}

	search(): void {
		(document.activeElement as HTMLElement)?.blur();
		this.loader = true;
		this.cleanSearch();
		this.sharedService.sendMessage('search', this.filter);
		this.loader = false;
	}

	resetForm() {
  		this.filter.filterMetadata = {};
	}

	/* This method will clean up the search filter before calling the back-end with the following rules:
    1. If the field has value and the filterOperator is missing, then by default filterOperator will be assigned with EQUAL.
    2. If the fieldOperator has value and the field is missing, then fieldOperator will be discarded.filter

    This method will not exhaustively repair all user mistakes during search, but it will solve the majority of such cases.
  */
	cleanSearch() {
  	if (!!this.filter.filterMetadata) {
  		Object.entries(this.filter.filterMetadata).forEach(([key, value]) => {
  			if (!key.includes('FilterOperation') && !key.includes('FilterOption')) {
  				const fieldFilterOperation = key + 'FilterOperation';
  				if (!!this.filter.filterMetadata && !this.filter.filterMetadata[fieldFilterOperation as keyof FilterDocumentMetadataFilterMetadata]) {
  					this.filter.filterMetadata[fieldFilterOperation as keyof FilterDocumentMetadataFilterMetadata] = 'EQUAL'!;
  				}
  			} else if (key.includes('FilterOperation')) {
  				const field = key.replace("FilterOperation", "");
  				if (!!this.filter.filterMetadata && !this.filter.filterMetadata[field as keyof FilterDocumentMetadataFilterMetadata]) {
  					delete this.filter.filterMetadata[key as keyof FilterDocumentMetadataFilterMetadata];
  				}
  			}
  		});
  	}
	}


  @HostListener('document:keydown.enter', ['$event'])
	onEnterKeyPressed(event: KeyboardEvent) {
		if (this.isFocus) {
			if (event.key === "Enter") {
				this.isFocus = false;
				this.search();
			}
		}
	}

  onMouseEnter() {
  	this.isFocus = true;
  	window.addEventListener('keydown', this.onEnterKeyPressed.bind(this));
  }

  onMouseLeave() {
  	this.isFocus = false;
  	window.removeEventListener('keydown', this.onEnterKeyPressed.bind(this));
  }

  validateInteger(inputName: string, value: string) {
    const integerPattern = /^-?\d+$/;
    this.isInteger[inputName] = value === '' || integerPattern.test(value);
  }
}
